<template>
    <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
    >
        <AlertMessage class="mt-5 inline-block" type="info" v-if="type">
            <template v-slot:icon>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class=""
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <circle cx="12" cy="12" r="9"></circle>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    <polyline points="11 12 12 12 12 16 13 16"></polyline>
                </svg>
            </template>
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <template v-slot:body>
                <span class="whitespace-pre-line">{{ explanation }}</span>
            </template>
        </AlertMessage>
    </transition>
</template>

<script>
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    name: 'ActivityTypeInfo',
    components: {
        AlertMessage,
    },
    props: {
        type: {
            type: String,
            required: false,
        },
    },
    computed: {
        explanation: function () {
            if (!this.type) {
                return null;
            }

            const explanations = {
                'fixed-quiz': this.$t('messages.explanation_activity_type_fixed_quiz'),
                'challenge-quiz': this.$t('messages.explanation_activity_type_challenge'),
                default: this.$t('messages.explanation_activity_type_default'),
            };

            return explanations[this.type];
        },
    },
};
</script>
